import React, { useState } from 'react';
import Search_icon from '../../img/eva_search-outline.png';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Table from './Table';

import Sigongtable from './Sigongtable';

//차량등록 모달창
function ExampleSigong(props) {
  const { buttonLabel, u_sigong, setSigong } = props;

  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  const resize = {
    width: '17px',
  };
  return (
    <>
      <span className="jungbok" onClick={toggle}>
        <img src={Search_icon} style={resize} />
      </span>

      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>{buttonLabel}</ModalHeader>
        <ModalBody>
          <Sigongtable u_sigong={u_sigong} setSigong={setSigong} />
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={toggle}>
            선택
          </Button>
          <Button color="secondary" onClick={toggle}>
            닫기
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ExampleSigong;
